import { Component, inject, OnInit } from '@angular/core';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppVersionService } from './service/appversion.service';
import { DbService } from './service/db.service';
import { LoginService } from './service/login.service';
import { ServiceWorkerService } from './service/serviceworker.service';
import { StorageService } from './service/storage.service';
import { VersionService } from './service/version.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
    showWaitingScreen = true;
    swService = inject(ServiceWorkerService);

    constructor(
        private platform: Platform,
        private statusBar: StatusBar,
        private translate: TranslateService,
        private versionService: VersionService,
        private appVersionService: AppVersionService,
        private loginService: LoginService,
        private dbService: DbService,
        private storage: StorageService,
        private nav: NavController
    ) {
        translate.setDefaultLang('fr');
        this.translate.use('fr');
        this.initializeApp();
    }

    async ngOnInit() {
        // Subscribe à l'initialisation du SW
        this.swService.init().subscribe({
            next: (success) => {
                console.log('SW Init:', success ? 'OK' : 'Erreur');
                this.hideWaitingScreen();
            },
            error: (err) => {
                console.error('Erreur SW:', err);
                this.hideWaitingScreen(); // Cacher même en cas d'erreur
            },
        });

        // Charger et stocker la version au démarrage
        await this.initializeVersion();

        this.handleOfflineRefresh();
    }

    hideWaitingScreen() {
        setTimeout(() => {
            this.showWaitingScreen = false;
        }, 500);
    }

    async initializeApp() {
        this.platform.ready().then(async () => {
            // Bloque en mode portrait
            // if (this.versionService.isMobileDevice()) {
            //   this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
            // }

            await this.dbService.initConnection();
            await this.dbService.runMigrationToRemoveRankingVerificationUniqueConstraint();
            const version = await this.versionService.isValidVersion(true);
            const auth = await this.loginService.isAuthenticated(true);
            if (auth) {
                this.loginService.updateLoginDate();
            }

            const navigation = this.getNavigationPath(auth, version);

            navigation.then(() => {
                return this.initEnvironnement().then((_) => {
                    this.statusBar.styleDefault();
                });
            });
        });
    }

    async initEnvironnement() {
        await this.storage
            .get('lang')
            .then(async (data) => {
                if (data) {
                    return this.translate.use(data);
                } else {
                    return this.translate
                        .use('fr')
                        .toPromise()
                        .then(() => {
                            return this.storage.set('lang', 'fr');
                        });
                }
            })
            .catch((err) => {
                console.error('err init env', err);
            });
    }

    private getNavigationPath(auth, version) {
        let navigation;

        if (auth && version) {
            navigation = this.nav.navigateRoot('/home');
        } else if (version) {
            navigation = this.nav.navigateRoot('/login');
        } else {
            navigation = this.nav.navigateRoot('/loading');
        }

        return navigation;
    }

    private async initializeVersion() {
        try {
            await this.appVersionService.loadAndStoreVersion();
        } catch (error) {
            console.error('Erreur initialisation version:', error);
        }
    }

    private handleOfflineRefresh() {
        // Détecter le mode offline
        window.addEventListener('online', () => {
            console.log('🌐 Connexion rétablie');
            // Optionnel : synchroniser les données
        });

        window.addEventListener('offline', () => {
            console.log('📴 Mode offline activé');
        });

        // Intercepter le beforeunload (F5, fermeture)
        window.addEventListener('beforeunload', (event) => {
            if (!navigator.onLine) {
                console.log('🔄 Refresh en mode offline détecté');

                // Forcer le Service Worker à prendre en charge
                if (
                    'serviceWorker' in navigator &&
                    navigator.serviceWorker.controller
                ) {
                    console.log('✅ Service Worker contrôle la page');
                    // Pas besoin de prévenir, le SW gère
                } else {
                    console.warn('⚠️ Aucun Service Worker actif');
                    // Optionnel : empêcher le refresh
                    event.preventDefault();
                    event.returnValue =
                        'Mode offline : êtes-vous sûr de vouloir recharger ?';
                }
            }
        });

        // Vérifier le contrôle SW au chargement
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
                console.log('📦 Service Worker prêt:', registration);
            });
        }
    }
}
